<template>
  <div class="modal-SOSSet">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">数据</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body">
        <template>
          <!-- <el-table v-loading="tableLoading"  :data="tableData">

            <el-table-column prop="name" label="功能"></el-table-column>

            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button type="primary" size="small" @click="operation(scope.$index, scope.row)">查看</el-button>
              </template>
            </el-table-column>

          </el-table> -->
          <el-tabs type="border-card" :before-leave='beforeLeave' v-model="activeName" style="height:538px">
            <el-tab-pane v-for="(item,i) in tableData" :key="i" :label="item.name">
              <component :is="item.currentRole" ref="component"/>
            </el-tab-pane>
          </el-tabs>
        </template>
      </div>
    </div>

    <AlarmInfo ref="AlarmInfo"  v-show="alarmInfoShow"  v-on:closeAlarmInfo="closeAlarmInfo"        >  </AlarmInfo>

    <BloodPressureAndHeartRate ref="BloodPressureAndHeartRate"   v-show="bloodPressureAndHeartRateShow"  v-on:closeBloodPressureAndHeartRate="closeBloodPressureAndHeartRate"     ></BloodPressureAndHeartRate>

  </div>
</template>

<script>

import AlarmInfo from "./AlarmInfo";
import BloodPressureAndHeartRate from "./BloodPressureAndHeartRate";


export default {
  name: "PageForDevice",
  data() {
    return {
      bloodPressureAndHeartRateShow:false,
      alarmInfoShow:false,
      userCode: '',
      activeName:'0',
      tableData: [
        {name: '报警信息',currentRole:'AlarmInfo',isNone:true},
        {name: '血压心率',currentRole:'BloodPressureAndHeartRate',isNone:false},
      ],
    }
  },
  components: {
    AlarmInfo,BloodPressureAndHeartRate
  },

  methods: {
    init(row) {
      this.userCode = row.userCode;
      this.activeName='0'
      this.tableData.forEach((item)=>{
        item.isNone=false
      })
      this.tableData[0].isNone=true
      this.$nextTick(() => {
        this.$refs.component[0].init(row.userCode)
      })
    },
    closeSelf() {
      this.$emit("closeWatchData");
    },
    beforeLeave(activeName){
      if(!this.tableData[parseInt(activeName)].isNone){
          this.tableData[parseInt(activeName)].isNone=true
          this.$nextTick(() => {
              this.$refs.component[parseInt(activeName)].init(this.userCode)
          })
      }
    }
  },

}


</script>

<style lang="scss" scoped>

.modal-SOSSet {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 1000px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }

    .modal-body {
      position: relative;
      padding: 20px;
      z-index: 99;
      height: 550px;
      /deep/.el-tabs--border-card {
        box-shadow:none;
        .el-tabs__content{
          padding: 3px;
        }
      }
    }


  }

}


.btn-close, .btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}

.btn-close {
  color: #313131;
  background-color: transparent;
}


.row {
  padding: 10px 0px;
}

.item {
  padding: 0px 20px;
}

.label {
  padding: 5px 0px;
}

</style>